export const PRIVACY = {
  slug: "/gizlilik-politikasi",
  title: "Gizlilik Politikası",
  updated: "Son Güncelleme Tarihi: 02.07.2024",
  sections: [
    {
      heading: "1. Genel Bilgilendirme",
      paragraphs: [
        "Bu Gizlilik Politikası, web sitemizi, Facebook, Instagram, WhatsApp ve diğer dijital platformlarımızı ziyaret eden kullanıcıların kişisel verilerinin hangi amaçlarla toplandığını, işlendiğini ve korunduğunu açıklar.",
      ],
    },
    {
      heading: "2. Toplanan Bilgiler",
      bullets: [
        "Ad Soyad",
        "Telefon Numarası",
        "E-posta Adresi",
        "IP Adresi",
        "Cihaz Bilgileri",
        "Tarayıcı Bilgileri",
        "Konum Bilgisi",
        "Facebook Lead Form bilgileri",
        "WhatsApp üzerinden paylaşılan bilgiler",
        "Çerezler (Cookies)",
        "Facebook Pixel ve benzeri analiz verileri",
      ],
    },
    {
      heading: "3. Kullanım Amaçları",
      bullets: [
        "Hizmet sunmak",
        "İletişime geçmek",
        "Kampanya ve duyurular göndermek",
        "Reklam performansını analiz etmek",
        "Hizmeti geliştirmek",
        "Yasal yükümlülükleri yerine getirmek",
      ],
    },
    {
      heading: "4. Facebook ve Meta Teknolojileri",
      paragraphs: [
        "Facebook Pixel, Meta Conversion API, Lead Ads, Messenger ve Instagram reklam teknolojileri kullanılabilir.",
      ],
    },
    {
      heading: "5. Çerezler",
      paragraphs: [
        "Site performansı, analiz ve reklam optimizasyonu amacıyla çerezler kullanılabilir.",
      ],
    },
    {
      heading: "6. Bilgilerin Paylaşılması",
      paragraphs: [
        "Yasal zorunluluklar dışında bilgiler üçüncü kişilere satılmaz. Hizmet sağlayıcılarla gerekli ölçüde paylaşılabilir.",
      ],
    },
    {
      heading: "7. Veri Güvenliği",
      paragraphs: ["SSL, güvenlik duvarları ve yetkilendirme sistemleri kullanılmaktadır."],
    },
    {
      heading: "8. Saklama Süresi",
      paragraphs: [
        "Veriler gerekli olduğu süre boyunca saklanır ve sonrasında silinir veya anonimleştirilir.",
      ],
    },
    {
      heading: "9. Haklarınız",
      paragraphs: [
        "Verilerinize erişme, düzeltme, silme ve işlemeye itiraz etme haklarına sahipsiniz.",
      ],
    },
    {
      heading: "10. İletişim",
      paragraphs: ["E-posta: info@turkiyeborsarobotu.com", "Telefon: +05391180130"],
    },
    {
      heading: "Facebook Lead Form Kısa Gizlilik Metni",
      paragraphs: [
        "Bu form aracılığıyla paylaştığınız kişisel bilgiler yalnızca sizinle iletişime geçmek ve talep ettiğiniz hizmet hakkında bilgi vermek amacıyla kullanılacaktır. Bilgileriniz üçüncü kişilerle satılmaz veya paylaşılmaz. Detaylı bilgi için Gizlilik Politikamızı inceleyebilirsiniz.",
      ],
    },
  ],
};

export const TERMS = {
  slug: "/kullanici-sozlesmesi",
  title: "Kullanıcı Sözleşmesi",
  updated: "",
  sections: [
    {
      heading: "1. Gizlilik Politikası",
      paragraphs: [
        "Kişisel veriler; iletişim, hizmet sunumu, reklam optimizasyonu, yasal yükümlülüklerin yerine getirilmesi amacıyla işlenebilir. Toplanabilecek veriler: ad soyad, telefon, e-posta, IP, cihaz bilgileri, çerez verileri ve Meta Lead Form bilgileri. Veriler gerekli süre boyunca güvenli şekilde saklanır ve üçüncü kişilere yalnızca yasal zorunluluk veya hizmet sağlayıcı desteği kapsamında aktarılır.",
      ],
    },
    {
      heading: "2. KVKK Aydınlatma Metni",
      paragraphs: [
        "6698 sayılı KVKK kapsamında veri sorumlusu olarak kişisel verileriniz açık rıza veya kanuni sebeplere dayanılarak işlenebilir. Başvuru, düzeltme, silme ve itiraz haklarınızı şirket iletişim adreslerinden kullanabilirsiniz.",
      ],
    },
    {
      heading: "3. Çerez Politikası",
      paragraphs: [
        "Web sitesi zorunlu, performans, analiz ve reklam çerezleri kullanabilir. Tarayıcı ayarlarınızdan çerez tercihlerinizi değiştirebilirsiniz.",
      ],
    },
    {
      heading: "4. Kullanım Şartları",
      paragraphs: [
        "Siteyi kullanan herkes bu şartları kabul etmiş sayılır. İçerikler izinsiz kopyalanamaz. Hizmetler önceden haber verilmeksizin değiştirilebilir.",
      ],
    },
    {
      heading: "5. Mesafeli Satış Sözleşmesi",
      paragraphs: [
        "Elektronik ortamda verilen siparişlerde tarafların hak ve yükümlülükleri, teslimat, ödeme, cayma hakkı ve uyuşmazlık hükümleri ilgili mevzuata uygun olarak uygulanır.",
      ],
    },
    {
      heading: "6. İptal ve İade Politikası",
      paragraphs: [
        "İptal ve iade koşulları satılan ürün veya hizmetin niteliğine göre yürürlükteki tüketici mevzuatı çerçevesinde uygulanır. Dijital hizmetlerde istisnalar geçerli olabilir.",
      ],
    },
    {
      heading: "7. Facebook Lead Form Gizlilik Metni",
      paragraphs: [
        "Bu formda paylaştığınız bilgiler yalnızca talebinizi karşılamak ve sizinle iletişime geçmek amacıyla kullanılacaktır. Bilgileriniz satılmaz. Detaylar Gizlilik Politikasında yer almaktadır.",
      ],
    },
  ],
};
